import * as React from 'react';
import type { Props as InputProps } from './Input';
import Input from './Input';
import type { ButtonFullProps } from './../Button/Button';
import Button from './../Button/Button';
import './input-with-button.scss';

type InputWithButtonProps = {
    buttonProps?: ButtonFullProps;
    buttonText?: string;
    children?: React.ReactNode;
};

export type Props = InputProps & InputWithButtonProps;

const defaultInputPadding = 16;

export const InputWithButton = React.forwardRef((props: Props, ref: React.ForwardedRef<HTMLInputElement>): JSX.Element => {
    const { buttonProps, buttonText, children, ...rest } = props;
    const buttonRef = React.useRef(null) as React.MutableRefObject<HTMLDivElement | null>;
    const [inputPadding, setPadding] = React.useState(defaultInputPadding);

    React.useEffect(() => {
        const buttonWidth = buttonRef?.current?.getBoundingClientRect()?.width;
        setPadding(buttonWidth ? buttonWidth + defaultInputPadding : defaultInputPadding);
    }, [buttonRef]);

    return (
        <div className="input-with-button">
            <Input {...rest} ref={ref} style={{ paddingRight: inputPadding }} />
            <div className="buttons-group-container" ref={buttonRef}>
                {children ??
                    (buttonProps && (
                        <Button buttonSize="small" {...buttonProps}>
                            {buttonText}
                        </Button>
                    ))}
            </div>
        </div>
    );
});

InputWithButton.displayName = 'InputWithButton';

export default InputWithButton;
